export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* 背景主图 */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=energetic%20youthful%20live%20streaming%20community%20backdrop%20with%20large%20soft%20watermelon%20red%20and%20lime%20green%20gradient%20shapes%2C%20floating%20chat%20bubbles%20and%20play%20button%20icons%2C%20dark%20rich%20warm%20ambient%20glow%2C%20abstract%20entertainment%20party%20vibe%2C%20clean%20composition%20with%20generous%20negative%20space&width=1920&height=1080&seq=hero-2026-bg&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/65 to-background-50"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 pt-28 md:pt-36 pb-20 md:pb-28 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          {/* 左侧文案 */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <span className="inline-flex items-center gap-2 bg-accent-400/20 border border-accent-300/40 text-accent-100 text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-dot"></span>
              直播互动 · 在线围观模式已开启
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-tight text-background-50 mt-6">
              蹲一个后续，
              <br className="hidden sm:block" />
              吃瓜就要<span className="text-primary-300">边播边聊</span>
            </h1>
            <p className="text-background-200/90 mt-5 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              弹幕实时讨论同步吐槽，连麦吃瓜让观点直接碰撞。进入直播间即可加入现场，与各路吃瓜群众一起蹲后续、追反转。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
              <a
                href="#live"
                className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-6 py-3.5 rounded-full whitespace-nowrap inline-flex items-center justify-center gap-2 transition-colors cursor-pointer"
              >
                <i className="ri-live-line text-lg"></i>
                在线围观
              </a>
              <a
                href="#connect"
                className="w-full sm:w-auto bg-background-50/10 hover:bg-background-50/20 backdrop-blur text-background-50 border border-background-100/25 font-medium px-6 py-3.5 rounded-full whitespace-nowrap inline-flex items-center justify-center gap-2 transition-colors cursor-pointer"
              >
                <i className="ri-mic-line text-lg"></i>
                上麦连麦
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="text-left">
                <p className="text-2xl font-bold text-background-50">23w+</p>
                <p className="text-background-300/80 text-xs mt-0.5">在线吃瓜群众</p>
              </div>
              <div className="w-px h-8 bg-background-100/20"></div>
              <div className="text-left">
                <p className="text-2xl font-bold text-background-50">1.2w+</p>
                <p className="text-background-300/80 text-xs mt-0.5">今日新爆点</p>
              </div>
              <div className="w-px h-8 bg-background-100/20"></div>
              <div className="text-left">
                <p className="text-2xl font-bold text-background-50">98%</p>
                <p className="text-background-300/80 text-xs mt-0.5">反转蹲到率</p>
              </div>
            </div>
          </div>

          {/* 右侧直播演示卡 */}
          <div className="w-full lg:w-1/2 max-w-lg mx-auto">
            <div className="bg-background-900/70 backdrop-blur-xl border border-background-100/15 rounded-2xl overflow-hidden shadow-xl">
              {/* 直播窗口 */}
              <div className="relative h-52 md:h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=vibrant%20young%20live%20streaming%20stage%20with%20a%20host%20gesturing%20animatedly%2C%20watermelon%20red%20and%20lime%20green%20dynamic%20lighting%2C%20fun%20chat%20overlays%2C%20engaged%20playful%20atmosphere%2C%20high%20energy%20entertainment%20broadcast&width=800&height=450&seq=hero-live-window&orientation=landscape"
                  alt="吃瓜频道正在直播中的互动现场画面"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="inline-flex items-center gap-1.5 bg-background-950/60 text-background-50 text-xs px-2.5 py-1 rounded-full whitespace-nowrap">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse-dot"></span>
                    正在直播
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2 bg-background-950/60 text-background-50 text-xs px-2.5 py-1 rounded-full whitespace-nowrap">
                  <i className="ri-fire-line text-primary-400"></i>
                  12.8万人围观
                </div>
                <div className="absolute bottom-3 right-3 bg-background-950/60 text-background-50 text-xs px-2.5 py-1 rounded-full whitespace-nowrap">
                  瓜田李下 · 连麦中
                </div>
              </div>
              {/* 弹幕栏 */}
              <div className="px-4 py-3 border-t border-background-100/10">
                <p className="text-background-200 text-xs leading-relaxed">
                  <span className="text-accent-300 font-medium">前排吃瓜：</span>
                  真的吗？我蹲一个后续反转！
                  <span className="mx-2 text-background-600">·</span>
                  <span className="text-primary-300 font-medium">抓马本马：</span>
                  这也太精彩了吧哈哈哈
                </p>
              </div>
              {/* 输入框 */}
              <div className="flex items-center gap-2 px-4 pb-4">
                <input
                  className="flex-1 bg-background-800/60 border border-background-100/15 rounded-full px-4 py-2.5 text-background-100 text-sm outline-none placeholder:text-background-400"
                  placeholder="发条弹幕，加入现场讨论…"
                  readOnly
                />
                <button className="w-10 h-10 shrink-0 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 flex items-center justify-center text-lg cursor-pointer transition-colors">
                  <i className="ri-send-plane-fill"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}